import  gql  from 'graphql-tag'

export const commissions = gql`query commissions{ 
    commissions{
            edges{
                node{
                    id,
                    data
                }
            }
        }
    }`;
